import { render } from "./card.vue?vue&type=template&id=3ad52b18"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ad52b18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ad52b18', __exports__)) {
    console.log('reload')
    api.reload('3ad52b18', __exports__)
  }
  
  module.hot.accept("./card.vue?vue&type=template&id=3ad52b18", () => {
    console.log('re-render')
    api.rerender('3ad52b18', render)
  })

}


export default __exports__